const PRIORITY_GROUPS = [
  "GlobalAdmin",
  "SeniorManagement",
  "AdminManager",
  "SalesManager",
  "AdminMember",
  "SalesMember",
];

export const compareGroupNames = (a: string, b: string): number => {
  const aIndex = PRIORITY_GROUPS.indexOf(a);
  const bIndex = PRIORITY_GROUPS.indexOf(b);

  if (aIndex !== -1 || bIndex !== -1) {
    const aRank = aIndex === -1 ? PRIORITY_GROUPS.length : aIndex;
    const bRank = bIndex === -1 ? PRIORITY_GROUPS.length : bIndex;
    return aRank - bRank;
  }

  return a.localeCompare(b);
};

export const sortGroupNames = (groups: string[]): string[] => [...groups].sort(compareGroupNames);

// The most senior group a user holds, considering only groups in the fixed
// priority order above (GlobalAdmin outranks SeniorManagement, etc). Groups
// outside that list don't have a seniority ranking and are ignored.
export const getMostSeniorGroup = (groups: string[]): string | null => {
  let mostSenior: string | null = null;
  let mostSeniorRank = Infinity;

  for (const group of groups) {
    const rank = PRIORITY_GROUPS.indexOf(group);
    if (rank !== -1 && rank < mostSeniorRank) {
      mostSeniorRank = rank;
      mostSenior = group;
    }
  }

  return mostSenior;
};
